import React from "react";
import { Route, Routes } from "react-router-dom";
import MainBibliographyPage from "./MainBibliographyPage";
import ProtectedRoute from "../../ProtectedRoute";
import AddEditBibliographyPage from "./AddEditBibliographyPage";
import ViewBibliographyPage from "./ViewBibliographyPage";
import PageNotFound from "../PageNotFound";

const BibliographyRouter: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={<ProtectedRoute element={<MainBibliographyPage />} />}
      />
      <Route
        path="create"
        element={<ProtectedRoute element={<AddEditBibliographyPage />} />}
      />
      <Route
        path=":_id/edit"
        element={<ProtectedRoute element={<AddEditBibliographyPage />} />}
      />
      <Route
        path=":_id"
        element={<ProtectedRoute element={<ViewBibliographyPage />} />}
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default BibliographyRouter;

